import React from 'react';
import { CTAButton } from '../ui/CTAButton';
import { ImagePlaceholder } from '../ui/ImagePlaceholder';
import { PriceDisplay } from '../ui/PriceDisplay';
import { ProgressBar } from '../ui/ProgressBar';
export function PricingSection() {
  return <section id="checkout" className="py-10 md:py-16 px-4 bg-ink" data-id="element-65">
      <div className="max-w-5xl mx-auto" data-id="element-66">
        <div className="text-center mb-8" data-id="element-67">
          <span className="text-[10px] uppercase font-bold text-accent tracking-[0.2em] mb-2 block" data-id="element-68">
            PRECIO DE LANZAMIENTO
          </span>
          <h2 className="text-[26px] md:text-[42px] text-cream" data-id="element-69">
            Tu acceso completo al sistema
          </h2>
        </div>

        <div className="bg-cream shadow-2xl border-2 border-pain flex flex-col md:flex-row overflow-hidden" data-id="element-70">
          {/* Left: Mockup */}
          <div className="w-full md:w-1/2 p-6 bg-white flex items-center justify-center" data-id="element-71">
            <img src="https://cdn.magicpatterns.com/uploads/vYBH1iBtHcPgMfHLQR8dbr/20260226_1941_Image_Generation_simple_compose_01kje1s901f0nt2fg5sqyw5pwe.png" alt="222 Cosméticos Naturales - Fórmulas Seguras y Rentables" className="w-full max-w-[80%] mx-auto" data-id="element-72" />
          </div>

          {/* Right: Price Block */}
          <div className="w-full md:w-1/2 p-6 md:p-10 flex flex-col justify-center" data-id="element-73">
            <div className="mb-4" data-id="element-74">
              <p className="text-[18px] text-muted line-through mb-1" data-id="element-75">
                Precio normal: <PriceDisplay price={97} data-id="element-76" /> USD
              </p>
              <div className="flex items-baseline gap-2" data-id="element-77">
                <span className="text-[52px] font-bold text-primary-dark leading-none" data-id="element-78">
                  <PriceDisplay price={14.99} data-id="element-79" />
                </span>
                <span className="text-[20px] font-bold text-primary-dark" data-id="element-80">
                  USD
                </span>
              </div>
            </div>

            <div className="space-y-1 mb-6" data-id="element-81">
              <p className="text-[16px] font-bold text-pain" data-id="element-82">
                Ahorrás <PriceDisplay price={82} data-id="element-83" /> USD hoy
              </p>
              <p className="text-[14px] text-ink" data-id="element-84">
                Menos que una crema comercial de farmacia.
              </p>
              <p className="text-[12px] italic text-muted" data-id="element-85">
                Menos de <PriceDisplay price={0.5} data-id="element-86" /> por día.
              </p>
            </div>

            <div className="mb-6" data-id="element-87">
              <ProgressBar data-id="element-88" />
            </div>

            <CTAButton className="w-full mb-3" isCheckout={true} data-id="element-89">
              → ACCEDER AL SISTEMA POR $14.99
            </CTAButton>

            <p className="text-[11px] italic text-muted text-center mb-3" data-id="element-90">
              Este precio es de lanzamiento. No garantizo que se mantenga.
            </p>

            <div className="text-center" data-id="element-91">
              <p className="text-[12px] text-muted font-bold" data-id="element-92">
                🔒 Compra protegida · PDF descargable al instante
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}